// import React, { useState, useEffect } from "react";
// import "../manageDoctor.css";
// import "./speciality.css";
// import clinicService from "../../../Services/clinicService";
// import utils from "../../../Utils";
// import SpecialityItem from "./specialityItem";
// import strings from "../../../Utils/strings";
// import SpecialtyCard from "../../../Widgets/speciality/specialityCard";
// import utilFunctions from "../../../Utils/utilFunctions";
import React, { useState, useEffect } from "react";
import "../manageDoctor.css";
import "./speciality.css";
import clinicService from "../../../Services/clinicService";
import utils from "../../../Utils";
import SpecialityItem from "./specialityItem";
import strings from "../../../Utils/strings";
import SpecialtyCard from "../../../Widgets/speciality/specialityCard";
import utilFunctions from "../../../Utils/utilFunctions";
import toast from "react-hot-toast";
import { t } from "../../../Utils/translate";
import classNames from "classnames";

function ViewSpecialityList() {
  const [specialityList, setSpecialityList] = useState([]);
  const [addSpeciality, setAddSpeciality] = useState(false);
  const [departmentName, setDepartmentName] = useState("");
  const [departmentNameErr, setDepartmentNameErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchSpeciality, setSearchSpeciality] = useState("");
  const [isSpecialityEditing, setIsSpecialityEditing] = useState(false);
  const [filteredSpeciality, setFilteredSpeciality] = useState([]);

  useEffect(() => {
    getSpecialtyDepartment();
  }, []);

  const handleSpecialtyInputChanges = (e) => {
    utilFunctions.handleSpecialtyInputChanges(
      e,
      setDepartmentName,
      setDepartmentNameErr
    );
  };

  // const getSpecialtyDepartment = async () => {
  //     try {
  //         setIsLoading(true)
  //         // const response = await clinicService.getDoctorSpecialtyDepart();
  //         const response = await clinicService.getDoctorSpecialtyDepart();
  //         setIsLoading(false)
  //         if (response) {
  //             if (response.departmentList && response.departmentList.length > 0) {
  //                 const doctorDepartment = response.departmentList;
  //                 const doctorDepartmentArr = [];
  //                 doctorDepartment.map((data) => {
  //                     let obj = {
  //                         label: data.departmentName,
  //                         value: data._id,
  //                         isEditable: data.isActive,
  //                     };
  //                     doctorDepartmentArr.push(obj);
  //                 });
  //                 setSpecialityList(doctorDepartmentArr);
  //                 setFilteredSpeciality(doctorDepartmentArr)
  //             } else {
  //                 setSpecialityList(utils.constants.doctorDepartmentList);
  //                 setFilteredSpeciality(utils.constants.doctorDepartmentList)
  //             }
  //         } else {
  //             setSpecialityList(utils.constants.doctorDepartmentList);
  //             setFilteredSpeciality(utils.constants.doctorDepartmentList)
  //         }
  //     } catch { }
  // };
  const getSpecialtyDepartment = async () => {
    try {
      setIsLoading(true);
      const response = await clinicService.getDoctorSpecialtyDepart();
      setIsLoading(false);

      if (
        response &&
        response.status === "success" &&
        response.data.departments
      ) {
        const departments = response.data.departments;
        const doctorDepartmentArr = departments.map((data) => ({
          label: data.departmentName,
          value: data._id,
          isEditable: true, // Assuming all departments are editable initially
        }));
        setSpecialityList(doctorDepartmentArr);
        setFilteredSpeciality(doctorDepartmentArr);
      } else {
        setSpecialityList(utils.constants.doctorDepartmentList);
        setFilteredSpeciality(utils.constants.doctorDepartmentList);
      }
    } catch (error) {
      console.error("Error fetching departments: ", error);
      setSpecialityList(utils.constants.doctorDepartmentList);
      setFilteredSpeciality(utils.constants.doctorDepartmentList);
    }
  };
  const onEditComplete = () => {
    let temp = specialityList;
    temp.map((item) => {
      item.isEditable = true;
    });
    setSpecialityList(temp);
  };

  const onEditItem = (index) => {
    const temp = specialityList;
    temp.map((item) => {
      item.isEditable = false;
    });
    temp[index].isEditable = true;
    setSpecialityList(temp);
  };

  const handleAddSpeciality = () => {
    if (!isSpecialityEditing) {
      setAddSpeciality(true);
    }
  };

  const handleEditClick = () => {
    setAddSpeciality(!addSpeciality);
  };

  const handleCloseDepart = () => {
    setAddSpeciality(!addSpeciality);
    setDepartmentName("");
    setDepartmentNameErr("");
  };

  const addDepartment = async () => {
    try {
      const body = {
        departmentName: departmentName,
      };
      const response = await clinicService.addSpeciality(body);
      if (response && response.status === strings.speciality.AlreadyExist) {
        setDepartmentNameErr(t("alreadyExistSpeciality"));
        utilFunctions.clearErrorMessages(setDepartmentNameErr);
        setSearchSpeciality("");
      } else {
        toast.dismiss();
        toast.success(t("specialitySuccess"));
        setSearchSpeciality("");
        setDepartmentName("");
        getSpecialtyDepartment();
        setAddSpeciality(false);
      }
    } catch {}
  };

  const handleSpecialityEdited = (isEdited) => {
    if (isEdited) {
      getSpecialtyDepartment();
      setSearchSpeciality("");
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchSpeciality(event.target.value);
    const filteredData = specialityList.filter((item) => {
      return item.label
        .toLowerCase()
        .includes(event.target.value.toLowerCase());
    });
    setFilteredSpeciality(filteredData);
  };

  const handleSearchClose = () => {
    setSearchSpeciality("");
    getSpecialtyDepartment();
  };
  const handleSpecialityEdit = (isEdit) => {
    setIsSpecialityEditing(isEdit);
  };

  return (
    <div>
      <div className="d-flex col-11 main-search">
        <div className="d-flex input-wrapper col-10">
          {searchSpeciality === "" ? (
            <i className="ri-search-line manage-icon search-icon search-icon-resp"></i>
          ) : (
            <i
              className="ri-close-circle-line manage-icon  search-icon "
              onClick={handleSearchClose}
            ></i>
          )}
          <input
            type="text"
            className={classNames(
              addSpeciality || isSpecialityEditing
                ? "control-input search-input speciality-list search-lg check-icon"
                : "control-input search-input speciality-list search-lg"
            )}
            placeholder={t("searchDeparment")}
            value={searchSpeciality}
            onChange={handleSearchInputChange}
            disabled={isSpecialityEditing || addSpeciality}
          />
          <input
            type="text"
            className={classNames(
              isSpecialityEditing || addSpeciality
                ? "control-input search-input speciality-list search-sm check-icon"
                : "control-input search-input speciality-list search-sm "
            )}
            placeholder={t("searchSpecialitySm")}
            value={searchSpeciality}
            onChange={handleSearchInputChange}
            disabled={isSpecialityEditing || addSpeciality}
          />
        </div>
        {/* <div
                    className='col-lg-3 mb-2'
                    onClick={handleAddSpeciality}>
                    <button
                        type="button"
                        className={addSpeciality || isSpecialityEditing ? "btn btn-danger text-nowrap d-flex speciality-btn check-icon" : "btn btn-danger text-nowrap d-flex speciality-btn"}
                        style={{
                            fontSize: '0.9rem'
                        }}
                    >
                        <i className="ri-add-line m"></i>
                        {t("labelSpecialization")}
                    </button>
                </div> */}
      </div>
      <div className="specialty-space">
        {addSpeciality && (
          <SpecialtyCard
            isEditable={addSpeciality}
            isSpecialityAdd={addSpeciality}
            value={departmentName}
            handleInputChanges={handleSpecialtyInputChanges}
            handleIsEditableClick={handleEditClick}
            handleClose={handleCloseDepart}
            placeholderLg={t("placeholderSpeciality")}
            placeholderSm={t("placeholderSpecialitySm")}
            handleEditChange={addDepartment}
            errorMessage={departmentNameErr}
          />
        )}
      </div>
      {isLoading ? (
        <></>
      ) : (
        <div
          style={{ maxHeight: "80vh", overflowY: "auto" }}
          className={classNames(
            addSpeciality
              ? "speciality-add speciality-list"
              : "speciality-list mb-3"
          )}
        >
          {filteredSpeciality &&
            filteredSpeciality.length > 0 &&
            filteredSpeciality.map((item, index) => {
              return (
                <div>
                  <>
                    <SpecialityItem
                      index={index}
                      item={item}
                      onEditComplete={onEditComplete}
                      onEditItem={onEditItem}
                      isSpecialityAdd={addSpeciality}
                      isEdited={handleSpecialityEdited}
                      isSpecialityEditable={handleSpecialityEdit}
                      isSpecialityEdited={handleSpecialityEdited}
                      isSearching={searchSpeciality}
                    />
                  </>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}

export default ViewSpecialityList;
